export const SESSION_WCP = {
    PROMO_REWIND: 'promoRewind',
    PPV_EVENT_ID: 'ppvEventId',
};
